import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm.js';
Swiper.use([Navigation, Pagination]);

import { createElement, throttle } from "../lib";
import {DEFER_INIT_EVENTS} from "../global/constants";

export default class CompaniesSlider {
	constructor(props = {}) {
		this.shouldDeferInit = props.shouldDeferInit == null ? true : props.shouldDeferInit;
		this.id = 'swiper-companies';
		this.$root = document.getElementById(this.id);

		this.config = {
			pagination: {
				el: '.swiper-slider_pagination',
				clickable: true,
				dynamicMainBullets: 3
			},
			spaceBetween: 60,
			slidesPerView: 1,
			slidesPerGroup: 1,
			breakpoints: {
				768: {
					spaceBetween: 30
				}
			}
		};

		this.tabletMedia = window.matchMedia('(min-width: 590px) and (max-width: 955px)').matches;
		this.mobileMedia = window.matchMedia('(max-width: 590px)').matches;

		this.itemList = [];

		this.rowNumber = 2;

		this.breakpoints = {
			955: {
				protector: false,
				action: () => {
					if (!this.breakpoints[955].protector) {
						this.rowNumber = 3;
					}
				}
			},
			590: {
				protector: false,
				action: () => {
					if (!this.breakpoints[590].protector) {
						this.rowNumber = 4;
					}
				}
			},
			default: {
				protector: false,
				action: () => {
					if (!this.breakpoints['default'].protector) {
						this.rowNumber = 2;
					}
				}
			}
		};

		this.swiper = null;

		if (this.$root) {

			if (this.shouldDeferInit) {
				this.deferInit();
			} else {
				this.init();
			}
		}
	}

	init() {
		this.getItems();
		this.renderSlides();
		this.bootstrap();
		this.handleResponsive();
	}

	deferInit() {
		const events = DEFER_INIT_EVENTS;
		const handler = e => {
			e.stopPropagation();

			const size = window.screen.width;


			if (this.tabletMedia) {
				this.breakpoints[955].action();
				this.breakpoints[955].protector = true;
			} else if (this.mobileMedia) {
				this.breakpoints[590].action();
				this.breakpoints[590].protector = true;
			} else {
				this.breakpoints['default'].action();
				this.breakpoints['default'].protector = true;
			}

			this.getItems();
			this.renderSlides();
			this.bootstrap();
			this.handleResponsive();

			events.forEach(event => {
				window.removeEventListener(event, handler);
			});
		};


		events.forEach(event => {
            window.addEventListener(event, handler);
		});
	}

	getItems() {
		const $companiesSectionContent = document.querySelector('.section.-companies .section-content');
		const $buffer = document.querySelector('.swiper-items-buffer');
		this.itemList = Array.from($buffer.children);

		$companiesSectionContent.removeChild($buffer);
	}

	createSlideContainer() {
		const slideList = this.createSlides();
		return createElement({
			name: 'div',
			className: 'swiper-wrapper',
			children: slideList
		});
	}

	createRows() {
		const rowList = [];
		let sortedItemList = [];
		let	rowLength;

		switch (this.rowNumber) {
			case 3:
				rowLength = 3;
				break;
			case 4:
				rowLength = 2;
				break;
			default:
				rowLength = 5;
				break;
		}

		this.itemList.forEach((item, i) => {
			sortedItemList.push(item);

			if (!((i + 1)%rowLength) || i === (this.itemList.length - 1)) {
				rowList.push(createElement({
					name: 'div',
					className: 'swiper-slide-row',
					children: sortedItemList
				}));

				sortedItemList = [];
			}
		});

		return rowList;
	}

	createSlides() {
		const rowList = this.createRows();
		const slideList = [];
		let sortedRowList = [];

		rowList.forEach((row, i) => {
			sortedRowList.push(row);

			if (!((i + 1)%this.rowNumber) || i === (rowList.length - 1)) {
				slideList.push(createElement({
					name: 'div',
					className: 'swiper-slide',
					children: sortedRowList
				}));

				sortedRowList = [];
			}
		});

		return slideList;
	}

	renderSlides() {
		const newContainer = this.createSlideContainer();
		const $container = this.$root.querySelector('.swiper-wrapper');

		this.$root.removeChild($container);
		this.$root.appendChild(newContainer);
	}

	updateSlides() {
		const slideList = this.createSlides();

		this.swiper.removeAllSlides();
		this.swiper.appendSlide(slideList);
		this.swiper.update();
		this.handlePagination();
	}

	bootstrap() {
		this.config.pagination.dynamicBullets = this.$root.querySelectorAll('.swiper-slide').length > 7;
		this.swiper = new Swiper(`#${this.id}`, this.config);
	}

	handleResponsive() {
		window.addEventListener('resize', throttle(() => {
			this.tabletMedia = window.matchMedia('(min-width: 590px) and (max-width: 955px)').matches;
			this.mobileMedia = window.matchMedia('(max-width: 590px)').matches;

			if (this.tabletMedia) {
				this.breakpoints[955].action();
				this.breakpoints[955].protector = true;
				this.breakpoints[590].protector = false;
				this.breakpoints['default'].protector = false;
				this.updateSlides();
			} else if (this.mobileMedia) {
				this.breakpoints[590].action();
				this.breakpoints[590].protector = true;
				this.breakpoints[955].protector = false;
				this.breakpoints['default'].protector = false;
				this.updateSlides();
			} else {
				this.breakpoints['default'].action();
				this.breakpoints['default'].protector = true;
				this.breakpoints[590].protector = false;
				this.breakpoints[955].protector = false;
				this.updateSlides();
			}
		}, 40));
	}

	handlePagination() {
		const $slidesContainer = this.$root.querySelector('.swiper-wrapper');

		if ($slidesContainer.children.length === 1) {
			this.$root.classList.add('-no-pagination');
		} else {
			this.$root.classList.remove('-no-pagination');
		}
	}
}